import { FormattedMessage } from 'react-intl';
import { Stack, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyTickets = () => (
  <Stack
    spacing={1}
    alignItems="center"
    justifyContent="center"
    sx={{ minHeight: 172, color: 'text.secondary', textAlign: 'center' }}>
    <InboxIcon color="disabled" />
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      <FormattedMessage id="freshdesk.emptyTickets" />
    </Typography>
    <Typography variant="caption">
      <FormattedMessage id="freshdesk.emptyTicketsHelper" />
    </Typography>
  </Stack>
);

export default EmptyTickets;
